import React from "react"
import HeroHome from "./layouts/HeroHome"
import Hero from "./layouts/Hero"
import TextBlocks from "./layouts/TextBlocks"
import FoodCards from "./layouts/FoodCards"
import Gallery from "./layouts/Gallery"
import ShopCards from "./layouts/ShopCards"
import Catering from "./layouts/Catering"
import Pdf from "./layouts/Pdf"
import TheBuzzBlogPosts from "./layouts/TheBuzzBlogPosts"
import MiscContent from "./layouts/MiscContent"
import MenuItemsLayout from "./layouts/MenuItemsLayout/menu-items-layout.component"
import JoinTheTeamForm from "./layouts/JoinTheTeamForm"

const getLayout = (layout, slug) => {
  const layoutName = layout?.fieldGroupName?.split("_").pop().trim()
  if (!layoutName) return null
  switch (layoutName) {
    case "HeroHome":
      return <HeroHome {...layout} />
    case "Hero":
      return <Hero {...layout} />
    case "TextBlocks":
      return <TextBlocks {...layout} slug={slug} />
    case "FoodCards":
      return <FoodCards {...layout} />
    case "Gallery":
      return <Gallery {...layout} />
    case "ShopCards":
      return <ShopCards {...layout} />
    case "Catering":
      return <Catering {...layout} />
    case "Pdf":
      return <Pdf {...layout} />
    case "TheBuzzBlogPosts":
      return <TheBuzzBlogPosts {...layout} />
    case "MiscContent":
      return <MiscContent {...layout} />
    case "MenuItemsLayout":
      return <MenuItemsLayout {...layout} />
    case "JoinTheTeamForm":
      return <JoinTheTeamForm {...layout} />
  }
}

export default getLayout
